import medpro from "./medpro";
import umc from "./umc";
import trungvuong from "./trungvuong";
import leloi from "./leloi";
import dkkvangiang from "./dkkvangiang";
import nhidong1 from "./nhidong1";
import yduoccs2 from "./yduoccs2";
import vanhanh from "./vanhanh";
import choray from "./choray";
import bvchoray_ttub from "./bvchoray_ttub";
import bv115 from "./115";
import bthh from "./bthh";
import dkvinhlong from "./dkvinhlong";
import momo from "./momo";
import dkdongnai from "./dkdongnai";
import dkdongnai2 from "./dkdongnai2";
import bvtndongnai from "./bvtndongnai";
import noitiettw from "./noitiettw";
import ctchhcm from "./ctchhcm";
import tvmbaclieu from "./tvmbaclieu";
import pkdkanhao from "./pkdkanhao";
import dkanphuoc from "./dkanphuoc";
import pkh from "./pkh";
import dalieuhcm from "./dalieuhcm";
import bvtwct from "./bvtwct";
import medicsaigon from "./medicsaigon";
import binhthanhhcm from "./binhthanhhcm";
import bvbnd from "./bvbnd";
import medprodanang from "./medprodanang";
import nhidonghcm from "./nhidonghcm";
import bvdktiengiang from "./bvdktiengiang";
import vientimhcm from "./vientimhcm";

import minhanh from "./minhanh";
export default {
  minhanh,
  vientimhcm,
  bvdktiengiang,
  medpro,
  umc,
  trungvuong,
  leloi,
  dkkvangiang,
  nhidong1,
  yduoccs2,
  vanhanh,
  choray,
  bvchoray_ttub,
  "115": bv115,
  bthh,
  dkvinhlong,
  momo,
  dkdongnai,
  noitiettw,
  ctchhcm,
  tvmbaclieu,
  pkdkanhao,
  dkanphuoc,
  pkh,
  dalieuhcm,
  bvtwct,
  medicsaigon,
  binhthanhhcm,
  bvbnd,
  medprodanang,
  dkdongnai2,
  bvtndongnai,
  nhidonghcm
};
